import React from 'react';

import Seo from '../ui/Seo';
import PageHero from '../sections/PageHero';
import TradeTicker from '../sections/TradeTicker';
import Pledge from '../sections/Pledge';
import StoryDeck from '../sections/StoryDeck';
import SectionHead from '../sections/SectionHead';
import Faqs from '../sections/Faqs';
import Cta from '../sections/Cta';

import ElectricalPanelUpgrades from "../media/images/residential-services/electrical-panel-upgrades.jpg";
import ServiceUpgrades from "../media/images/residential-services/service-upgrades.jpg";
import NewConstruction from "../media/images/residential-services/new-construction.jpg";
import LedRecessedLighting from "../media/images/residential-services/led-recessed-lighting.jpg";
import GeneratorInstallations from "../media/images/residential-services/generator-installations.jpg";
import LandscapeLighting from "../media/images/residential-services/landscape-lighting.jpg";
import GeneralRepairsInstallations from "../media/images/residential-services/general-repairs-installations.jpg";
import SmartHomes from "../media/images/residential-services/smart-homes.jpg";
import AcHookups from "../media/images/residential-services/ac-hookups.jpg";
import ServiceCalls from "../media/images/residential-services/service-calls.jpg";

const content =
[
    {
        title: "Electrical Panel Upgrades & Replacements",
        text: "Upgrade your electrical panel to support modern appliances and ensure safety. Prevent hazards from outdated panels with reliable upgrades by Smart Electric Solutions.",
        imgSrc: ElectricalPanelUpgrades,
        alt: "Smart Electric Solutions - Electrical Panel Upgrades",
        focus: "20%",
    },
    {
        title: "Service Upgrades",
        text: "Upgrade outdated systems or prepare for renovations with efficient, modern technology. Our skilled electricians deliver fast, accurate solutions tailored to your needs.",
        imgSrc: ServiceUpgrades,
        alt: "Smart Electric Solutions - Service Upgrades",
        focus: "55%",
    },
    {
        title: "New Construction & Renovations",
        text: "Ensure safety and reliability in new builds or renovations with quality electrical installations. Our energy-efficient systems comply with safety codes and enhance your home’s value.",
        imgSrc: NewConstruction,
        alt: "Smart Electric Solutions - New Construction and Renovations",
        focus: "40%",
    },
    {
        title: "LED Recessed Lighting",
        text: "Brighten your home with energy-saving LED recessed lighting. These stylish fixtures consume less energy, last longer, and enhance modern aesthetics.",
        imgSrc: LedRecessedLighting,
        alt: "Smart Electric Solutions - LED Recessed Lighting",
        focus: "50%",
    },
    {
        title: "Generator Installations",
        text: "Prepare for outages with a reliable generator. We handle site preparation, installation, and connections to ensure smooth operation during power interruptions.",
        imgSrc: GeneratorInstallations,
        alt: "Smart Electric Solutions - Generator Installations",
        focus: "70%",
    },
    {
        title: "Landscape Lighting",
        text: "Illuminate your outdoor spaces with durable, custom-designed lighting. Enhance security and create an inviting ambiance for your yard.",
        imgSrc: LandscapeLighting,
        alt: "Smart Electric Solutions - Landscape Lighting",
        focus: "50%",
    },
    {
        title: "General Repairs & Installations",
        text: "From faulty outlets to complete upgrades, we provide fast, reliable electrical repairs and installations to keep your home running safely.",
        imgSrc: GeneralRepairsInstallations,
        alt: "Smart Electric Solutions - Repairs and Installations",
        focus: "50%",
    },
    {
        title: "Smart Homes",
        text: "Upgrade your home with automated lighting, locks, and security systems. Control everything remotely with our advanced smart home solutions.",
        imgSrc: SmartHomes,
        alt: "Smart Electric Solutions - Smart Home Technologies",
        focus: "70%",
    },
    {
        title: "A/C Hookups",
        text: "Stay cool year-round with quick, precise A/C hookups. Our technicians ensure efficient installation for reliable cooling from day one.",
        imgSrc: AcHookups,
        alt: "Smart Electric Solutions - A/C Hookups",
        focus: "65%",
    },
    {
        title: "Service Calls",
        text: "Need electrical help? Our licensed electricians provide prompt, expert solutions for minor issues or urgent repairs, prioritizing safety and performance.",
        imgSrc: ServiceCalls,
        alt: "Smart Electric Solutions - Service Calls",
        focus: "65%",
    }
];

export default function ResidentialServices() {
    return (
        <>
            <Seo
                title="Residential Electrical Services"
                description="Residential electrical services across South Florida: panel upgrades, service upgrades, LED recessed lighting, generators, landscape lighting, smart homes and same-day service calls."
                keywords="residential electrician, electrical panel upgrade, service upgrade, LED recessed lighting, generator installation, landscape lighting, smart home wiring, South Florida"
                path="/residential-services"
                schema={{
                    '@type': 'WebPage',
                    name: 'Residential Electrical Services',
                    description: 'Residential electrical services across South Florida: panel upgrades, service upgrades, LED recessed lighting, generators, landscape lighting, smart homes and same-day service calls.',
                    url: 'https://smartelectric.solutions/residential-services'
                }}
            />

            <PageHero
                eyebrow="Spaces"
                title="Power for the way your home actually runs."
                lead="Panels, service, lighting and standby power, sized for the loads a modern house puts on a system that was often specified decades ago."
                backdrop={content[0].imgSrc}
                focus={`${content[0].focus} center`}
                crumbs={[{ label: 'Spaces' }, { label: 'Residential Services' }]}
            />

            <TradeTicker />

            <section className="section section--tight">
                <div className="shell">
                    <Pledge />
                </div>
            </section>

            <section className="section section--ruled">
                <div className="shell">
                    <SectionHead
                        eyebrow="What we do"
                        title="Residential work, end to end."
                        lead="From a single service call to a whole-house rewire, with the same licensed crews and the same documentation either way."
                    />
                </div>

                <div style={{ marginTop: 'clamp(2.5rem, 6vw, 4rem)' }}>
                    <StoryDeck items={content} />
                </div>
            </section>

            <Faqs />
            <Cta />
        </>
    );
}
